import { render, staticRenderFns } from "./ActivityFeed.vue?vue&type=template&id=1097ce4e&scoped=true"
import script from "./ActivityFeed.vue?vue&type=script&lang=js"
export * from "./ActivityFeed.vue?vue&type=script&lang=js"
import style0 from "./ActivityFeed.vue?vue&type=style&index=0&id=1097ce4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1097ce4e",
  null
  
)

export default component.exports